import * as React from 'react';

export function renderSVGText(text: string, chars: number, lineheight: number, x: number, y: number, hr_w: number, text_color?: string) {
    const arr = wrapText(text, chars);
    // console.log('WORDS:', arr, text, chars);
    return (
        <g>
            {arr.map((str: string, index: number) => {
                if (str === ' #hr# ') {
                    return (
                        <line
                            key={`text-${index}`}
                            x1={x}
                            x2={x + hr_w}
                            y1={y + lineheight * index - (lineheight * 0.3)}
                            y2={y + lineheight * index - (lineheight * 0.3)}
                            style={{ stroke: '#fafafa', strokeWidth: 2 }}
                        />
                    );
                } else if (str === ' #br# ') {
                    return (
                        <text
                            key={`text-${index}`}
                            x={x}
                            y={y + lineheight * index}
                        >
                            {''}
                        </text>
                    );
                } else {
                    return (
                        <text
                            key={`text-${index}`}
                            x={x}
                            y={y + lineheight * index}
                            style={{ fontSize: '12px', fontWeight: 'bold', fill: text_color ? text_color : '#555' }}
                        >
                            {str}
                        </text>
                    );
                }
            })}
        </g>
    );
}

export function wrapText(input: string, maxChars: number): Array<string> {
    // console.log(input, maxChars);
    const lines: Array<string> = [];
    let blockSeparator = ' #br# ';
    if (input.indexOf(' #hr# ') !== -1) {
        blockSeparator = ' #hr# ';
    }

    input.split(blockSeparator).forEach((string: string) => {
        string.split('\n').forEach((words: string) => {
            let line = '';
            words.split(' ').forEach((w: string) => {
                if (line.length + w.length <= maxChars) {
                    line += ' ' + w;
                } else {
                    lines.push(line);
                    // if (w.length > maxChars) {
                    //     const wh = getWordBreaks(w, maxChars);
                    //     wh.forEach((l: string, i: number) => {
                    //         if (i === wh.length - 1) {
                    //             line = l;
                    //         } else {
                    //             lines.push(l + '-');
                    //         }
                    //     });
                    // } else {
                    //     line = w;
                    // }
                    line = w;
                }
            });
            lines.push(line);
        });
        lines.push(blockSeparator);
    });

    return lines;
}

function getWordBreaks(w: string, maxChars: number) {
    const wh: Array<string> = [];
    for (let i = 0; i <= w.length; i += maxChars) {
        wh.push(w.substring(i, i + maxChars));
    }
    return wh;
}

export function wrapText_OLD(input: string, maxChars: number): Array<string> {
    const texts: Array<string> = [];
    //  The following two variables should really be passed as parameters
    const MAXIMUM_CHARS_PER_LINE = maxChars;
    // console.log('INPUT', input);
    // console.log('INPUT2', input.replace('\r', ' #br# '));
    // console.log('INPUT3', input.replace('\n', ' #br# '));

    const words = input.split('\n').join(' #br# ').split(' ');
    let line = '';

    for (let n = 0; n < words.length; n++) {
        if (words[n] === '#br#') {
            texts.push(line);
            line = '';
            continue;
        }
        if (words[n] === '#hr#') {
            texts.push(line);
            texts.push(words[n]);
            line = '';
            continue;
        }
        const testLine = line + words[n] + ' ';
        if (testLine.length > MAXIMUM_CHARS_PER_LINE) {
            texts.push(line);
            line = words[n];
        } else {
            line = testLine;
        }
    }
    if (line !== '') {
        texts.push(line);
    }
    console.log('TEXTS', input);
    return texts;
}
